import { createConfig, configureChains, WagmiConfig, Chain } from 'wagmi'
import { mainnet, sepolia } from 'wagmi/chains'
import { toast } from 'react-toastify'
import { infuraProvider } from 'wagmi/providers/infura'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import config from '../../config'
import React, { useCallback } from 'react'
import { WalletProvider as TronWalletProvider } from '@tronweb3/tronwallet-adapter-react-hooks'
import { TronLinkAdapter } from '@tronweb3/tronwallet-adapter-tronlink'
import { TrustAdapter } from '@tronweb3/tronwallet-adapter-trust'
import { Web3Provider } from './Web3Provider'
import { useTranslation } from 'react-i18next'

const isProduction = import.meta.env.MODE === 'production'
const selectedChains: Chain[] = isProduction ? [mainnet] : [sepolia]
const { chains, publicClient, webSocketPublicClient } = configureChains(selectedChains, [
  infuraProvider({ apiKey: config.crypto.infuraApiKey }),
])

const wagmiConfig = createConfig({
  publicClient,
  webSocketPublicClient,
  autoConnect: true,
  connectors: [
    new InjectedConnector({ chains }),
    new WalletConnectConnector({
      chains,
      options: {
        projectId: config.crypto.walletConnectId,
        qrModalOptions: {
          enableExplorer: false,
          explorerRecommendedWalletIds: 'NONE',
        },
      },
    }),
  ],
})

const tronAdapters = [
  new TrustAdapter(),
  new TronLinkAdapter({
    dappName: 'Bivial A.G', // TODO:
  }),
  // new WalletConnectAdapter({
  //   network: isProduction ? 'Mainnet' : 'Shasta',
  //   options: {
  //     projectId: config.crypto.walletConnectId,
  //   },
  // }),
]

export function WalletProvider({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation()
  const onError = useCallback((e) => {
    toast.error(
      (e as any).message ||
        t('unableToConnectWallet', "Wallet can't be connected. Please contact support."),
    )
  }, [])

  return (
    <TronWalletProvider
      onError={onError}
      adapters={tronAdapters}
      disableAutoConnectOnLoad={true}
      autoConnect
    >
      <WagmiConfig config={wagmiConfig}>
        <Web3Provider>{children}</Web3Provider>
      </WagmiConfig>
    </TronWalletProvider>
  )
}
